import { Injectable } from '@angular/core';
import { MAP_CONSTANTS, PATHS, GAM_PRODUCT_SEPERATED_Rs } from '../../../analytics/constants/analytics.constants';
import * as _ from 'underscore';
import { UtilityService } from '../../../../core/utility/services/utility.service';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';

export interface MapLegendItem {
	productName: string;
	productKey: string;
	isSelected: boolean;
	isDisabled: boolean;
	isDependent: boolean;
	showInLegend: boolean;
	showLiftHover: boolean;
	show: boolean;
	hasGeoFence: boolean;
	productRelated: string;
}

export interface MapInterface {
	combinations: any;
	legend: MapLegendItem[];
}

@Injectable()
export class MapComponentService {
	private _mapData: any;
	private _selectedState: string;
	private _barsCount: number;

	private _allRegions: any[] = [];
	private _displayRegions: any[] = [];
	private _prerollRegions: any[] = [];
	private _semRegions: any[] = [];
	private _tvRegions: any[] = [];
	private _ctvRegions: any[] = [];
	private _radioRegions: any[] = [];
	private _tritonRadioRegions: any[] = [];
	private _gamRegions: any[] = [];
	private _responsiveDisplayRegions: any[] = [];
	private _simplifiCTVRegions: any[] = [];
	private _legendItems: MapLegendItem[] = [];
	private _regionObj: any = {};

	private _displayGeofenceObj: any = {};
	private _displayGeorecencyObj: any = {};

	private _doohGeorecencyObj: any = {};

	private _prerollGeofenceObj: any = {};
	private _prerollGeorecencyObj: any = {};

	private _defaultProducts: any = [];
	private _geofenceProducts: any = [];
	private _showThirdPartyRTG: boolean;

	private filterProperty = 'gcd_id';
	private localIdProperty = 'local_id';

	private _enableGeofence: boolean;

	constructor(protected analyticsDataModel: AnalyticsDataModel) {
		this.barsCount = 5;
	}

	get mapData(): any {
		return this._mapData;
	}

	set mapData(value: any) {
		this._mapData = value.data;
		this._enableGeofence = value.condition;
		this.processMapData();
	}

	get selectedState(): string {
		return this._selectedState;
	}

	set selectedState(value: string) {
		this._selectedState = value;
	}

	get barsCount(): number {
		return this._barsCount;
	}

	set barsCount(value: number) {
		this._barsCount = value;
	}

	get allRegions(): any[] {
		return this._allRegions;
	}

	set allRegions(value: any[]) {
		this._allRegions = value;
	}

	get displayRegions(): any[] {
		return this._displayRegions;
	}

	set displayRegions(value: any[]) {
		this._displayRegions = value;
	}

	get prerollRegions(): any[] {
		return this._prerollRegions;
	}

	set prerollRegions(value: any[]) {
		this._prerollRegions = value;
	}

	get semRegions(): any[] {
		return this._semRegions;
	}

	set semRegions(value: any[]) {
		this._semRegions = value;
	}

	get tritonRadioRegions(): any[] {
		return this._tritonRadioRegions;
	}

	set tritonRadioRegions(value: any[]) {
		this._tritonRadioRegions = value;
	}

	get gamRegions(): any[] {
		return this._gamRegions;
	}

	set gamRegions(value: any[]) {
		this._gamRegions = value;
	}

	get responsiveDisplayRegions(): any[] {
		return this._responsiveDisplayRegions;
	}

	set responsiveDisplayRegions(value: any[]) {
		this._responsiveDisplayRegions = value;
	}

	get tvRegions(): any[] {
		return this._tvRegions;
	}

	set tvRegions(value: any[]) {
		this._tvRegions = value;
	}

	get ctvRegions(): any[] {
		return this._ctvRegions;
	}

	set ctvRegions(value: any[]) {
		this._ctvRegions = value;
	}

	get radioRegions(): any[] {
		return this._radioRegions;
	}

	set radioRegions(value: any[]) {
		this._radioRegions = value;
	}

	get simplifiCTVRegions(): any[] {
		return this._simplifiCTVRegions;
	}

	set simplifiCTVRegions(value: any[]) {
		this._simplifiCTVRegions = value;
	}

	get legendItems(): MapLegendItem[] {
		return this._legendItems;
	}

	set legendItems(value: MapLegendItem[]) {
		this._legendItems = value;
	}

	get regionObj(): any {
		return this._regionObj;
	}

	set regionObj(value: any) {
		this._regionObj = value;
	}

	get displayGeofenceObj(): any {
		return this._displayGeofenceObj;
	}

	set displayGeofenceObj(value: any) {
		this._displayGeofenceObj = value;
	}

	get displayGeorecencyObj(): any {
		return this._displayGeorecencyObj;
	}

	set displayGeorecencyObj(value: any) {
		this._displayGeorecencyObj = value;
	}

	get doohGeorecencyObj(): any {
		return this._doohGeorecencyObj;
	}

	set doohGeorecencyObj(value: any) {
		this._doohGeorecencyObj = value;
	}

	get prerollGeofenceObj(): any {
		return this._prerollGeofenceObj;
	}

	set prerollGeofenceObj(value: any) {
		this._prerollGeofenceObj = value;
	}

	get prerollGeorecencyObj(): any {
		return this._prerollGeorecencyObj;
	}

	set prerollGeorecencyObj(value: any) {
		this._prerollGeorecencyObj = value;
	}

	get defaultProducts(): any {
		return this._defaultProducts;
	}

	set defaultProducts(value: any) {
		this._defaultProducts = value;
	}

	get geofenceProducts(): any {
		return this._geofenceProducts;
	}

	set geofenceProducts(value: any) {
		this._geofenceProducts = value;
	}

	get showThirdPartyRTG(): boolean {
		return this._showThirdPartyRTG;
	}

	set showThirdPartyRTG(value: boolean) {
		this._showThirdPartyRTG = value;
	}

	get enableGeofence(): boolean {
		return this._enableGeofence;
	}

	set enableGeofence(value: boolean) {
		this._enableGeofence = value;
	}

	setSelectedStateByPath(path) {
		if (path === PATHS.PREROLL || path === 'video') {
			this.selectedState = MAP_CONSTANTS.STATE.PREROLL;
		} else if (path === PATHS.DISPLAY) {
			this.selectedState = MAP_CONSTANTS.STATE.DISPLAY;
		} else if (path === PATHS.SEM) {
			this.selectedState = MAP_CONSTANTS.STATE.SEM;
		} else if (path === PATHS.OVERVIEW) {
			this.selectedState = MAP_CONSTANTS.STATE.ALL;
		} else if (path === PATHS.CTV) {
			this.selectedState = MAP_CONSTANTS.STATE.CTV;
		} else if (path === PATHS.SOCIAL) {
			this.selectedState = MAP_CONSTANTS.STATE.SOCIAL;
		} else if (path === PATHS.TELEVISION) {
			this.selectedState = MAP_CONSTANTS.STATE.TELEVISION;
		} else if (path === PATHS.TELEVISION_MIDCO) {
			this.selectedState = MAP_CONSTANTS.STATE.TELEVISION_MIDCO;
		} else if (path === PATHS.GEOVIDEO) {
			this.selectedState = MAP_CONSTANTS.STATE.GEOVIDEO;
		} else if (path === PATHS.GEOFENCE) {
			this.selectedState = MAP_CONSTANTS.STATE.GEOFENCE;
		} else if (path === PATHS.RADIO) {
			this.selectedState = MAP_CONSTANTS.STATE.RADIO;
		} else if (path === PATHS.SIMPLIFI_CTV) {
			this.selectedState = MAP_CONSTANTS.STATE.SIMPLIFI_CTV;
		} else if (path === PATHS.TRITON_AUDIO) {
			this.selectedState = MAP_CONSTANTS.STATE.TRITON_AUDIO;
		} else if (path === PATHS.RESPONSIVE_DISPLAY) {
			this.selectedState = MAP_CONSTANTS.STATE.RESPONSIVE_DISPLAY;
		} else if (path === PATHS.GAM) {
			this.selectedState = MAP_CONSTANTS.STATE.GAM;
		} else if (path === PATHS.DOOH) {
			this.selectedState = MAP_CONSTANTS.STATE.DOOH;
		}
	}

	processMapData() {
		const regionData = this.mapData[this.selectedState];
		const gfProduct = _.findWhere(this.geofenceProducts, { productKey: MAP_CONSTANTS.STATE.GEOFENCE });
		const geoVideoProduct = _.findWhere(this.geofenceProducts, { productKey: MAP_CONSTANTS.STATE.GEOVIDEO });
		const geoDOOHProduct = _.findWhere(this.geofenceProducts, { productKey: MAP_CONSTANTS.STATE.DOOH });
		let displayGeoFenceData = {},
			prerollGeoFenceData = {},
			doohGeoRecencyData = {};

		if (gfProduct) {
			displayGeoFenceData =
				!UtilityService.isUndefinedOrNull(this.mapData[MAP_CONSTANTS.STATE.DISPLAY]) &&
				this.mapData[MAP_CONSTANTS.STATE.DISPLAY].geofence_multipoints !== ''
					? JSON.parse(this.mapData[MAP_CONSTANTS.STATE.DISPLAY].geofence_multipoints)
					: {};
		}
		if (geoDOOHProduct) {
			doohGeoRecencyData =
				!UtilityService.isUndefinedOrNull(this.mapData[MAP_CONSTANTS.STATE.DOOH]) &&
				this.mapData[MAP_CONSTANTS.STATE.DOOH].geofence_multipoints !== ''
					? JSON.parse(this.mapData[MAP_CONSTANTS.STATE.DOOH].geofence_multipoints)
					: {};
		}
		if (geoVideoProduct) {
			prerollGeoFenceData =
				!UtilityService.isUndefinedOrNull(this.mapData[MAP_CONSTANTS.STATE.PREROLL]) &&
				this.mapData[MAP_CONSTANTS.STATE.PREROLL].geofence_multipoints !== ''
					? JSON.parse(this.mapData[MAP_CONSTANTS.STATE.PREROLL].geofence_multipoints)
					: {};
		}

		/**
		 * for geovideo and geofence as individual product
		 */
		if (!gfProduct && !geoVideoProduct) {
			if (this.selectedState === MAP_CONSTANTS.STATE.GEOFENCE) {
				displayGeoFenceData =
					!UtilityService.isUndefinedOrNull(this.mapData[MAP_CONSTANTS.STATE.GEOFENCE]) &&
					this.mapData[MAP_CONSTANTS.STATE.GEOFENCE].geofence_multipoints !== ''
						? JSON.parse(this.mapData[MAP_CONSTANTS.STATE.GEOFENCE].geofence_multipoints)
						: {};
			}

			if (this.selectedState === MAP_CONSTANTS.STATE.GEOVIDEO) {
				prerollGeoFenceData =
					!UtilityService.isUndefinedOrNull(this.mapData[MAP_CONSTANTS.STATE.GEOVIDEO]) &&
					this.mapData[MAP_CONSTANTS.STATE.GEOVIDEO].geofence_multipoints !== ''
						? JSON.parse(this.mapData[MAP_CONSTANTS.STATE.GEOVIDEO].geofence_multipoints)
						: {};
			}

			if (this.selectedState == 'all' && this.enableGeofence) {
				displayGeoFenceData =
					!UtilityService.isUndefinedOrNull(this.mapData[MAP_CONSTANTS.STATE.DISPLAY]) &&
					this.mapData[MAP_CONSTANTS.STATE.DISPLAY].geofence_multipoints !== ''
						? JSON.parse(this.mapData[MAP_CONSTANTS.STATE.DISPLAY].geofence_multipoints)
						: {};

				prerollGeoFenceData =
					!UtilityService.isUndefinedOrNull(this.mapData[MAP_CONSTANTS.STATE.PREROLL]) &&
					this.mapData[MAP_CONSTANTS.STATE.PREROLL].geofence_multipoints !== ''
						? JSON.parse(this.mapData[MAP_CONSTANTS.STATE.PREROLL].geofence_multipoints)
						: {};
			}
		}

		this.processGeoFenceAndGeoRecencyData(displayGeoFenceData, prerollGeoFenceData, doohGeoRecencyData);
		const regions = regionData?.['zr_regions'] ?? [];
		const prerollRegions = [];
		const displayRegions = [];
		const semRegions = [];
		const ctvRegions = [];
		const tvRegions = [];
		const radioRegions = [];
		const simplifiCTVRegions = [];
		const tritonRadioRegions = [];
		const responsiveDisplayRegions = [];
		const gamRegions = [];
		if (regions) {
			let tempPermissions = [];
			tempPermissions = this.analyticsDataModel.setupData.permissions;
			let isR13: boolean =
				this.analyticsDataModel.config.directoryName === 'lee-r13' ||
				this.analyticsDataModel.config.directoryName === 'default-r13'
					? true
					: false;
			let gam_seperated = !isR13
				? GAM_PRODUCT_SEPERATED_Rs.includes(this.analyticsDataModel.config.directoryName)
				: tempPermissions.includes('hasStandaloneGAM') &&
				  GAM_PRODUCT_SEPERATED_Rs.includes(this.analyticsDataModel.config.directoryName);
			for (const region of regions) {
				if (!gam_seperated && tempPermissions.includes('hasGamMapAccess')) {
					if (parseInt(region.preroll)) {
						prerollRegions.push(region);
					}
					if (parseInt(region.display)) {
						displayRegions.push(region);
					}
				} else {
					if (parseInt(region.preroll) && !parseInt(region.gam)) {
						prerollRegions.push(region);
					}
					if (parseInt(region.display) && !parseInt(region.gam)) {
						displayRegions.push(region);
					}
					if (parseInt(region.gam)) {
						gamRegions.push(region);
					}
				}
				if (parseInt(region.sem)) {
					semRegions.push(region);
				}
				if (parseInt(region.ctv)) {
					ctvRegions.push(region);
				}
				if (parseInt(region.tv)) {
					tvRegions.push(region);
				}
				if (parseInt(region.radio)) {
					radioRegions.push(region);
				}
				if (parseInt(region.simplifi_ctv)) {
					simplifiCTVRegions.push(region);
				}
				if (parseInt(region.triton_radio)) {
					tritonRadioRegions.push(region);
				}
				if (parseInt(region.responsive_display)) {
					responsiveDisplayRegions.push(region);
				}
			}
			this.prerollRegions = prerollRegions;
			this.displayRegions = displayRegions;
			this.semRegions = semRegions;
			this.ctvRegions = ctvRegions;
			this.tvRegions = tvRegions;
			this.radioRegions = radioRegions;
			this.simplifiCTVRegions = simplifiCTVRegions;
			this.tritonRadioRegions = tritonRadioRegions;
			this.responsiveDisplayRegions = responsiveDisplayRegions;
			this.gamRegions = gamRegions;
			this.allRegions = regions;
		} else {
			this.allRegions = [];
			this.displayRegions = [];
			this.prerollRegions = [];
			this.semRegions = [];
			this.ctvRegions = [];
			this.tvRegions = [];
			this.radioRegions = [];
			this.simplifiCTVRegions = [];
			this.tritonRadioRegions = [];
			this.responsiveDisplayRegions = [];
			this.gamRegions = [];
		}
	}

	private processGeoFenceAndGeoRecencyData(displayGeofenceObj, prerollGeofenceObj, doohGeoRecencyData) {
		let displayGeoRecency = [];
		let displayGeoFence = [];

		let doohGeoRecency = [];

		let prerollGeoRecency = [];
		let prerollGeoFence = [];

		if (displayGeofenceObj.features) {
			for (const feature of displayGeofenceObj.features) {
				if (!!feature.properties.is_rtg_center) {
					displayGeoRecency.push(feature);
				} else {
					displayGeoFence.push(feature);
				}
			}
		}
		if (doohGeoRecencyData.features) {
			for (const feature of doohGeoRecencyData.features) {
				doohGeoRecency.push(feature);
			}
		}

		if (prerollGeofenceObj.features) {
			for (const feature of prerollGeofenceObj.features) {
				if (!!feature.properties.is_rtg_center) {
					prerollGeoRecency.push(feature);
				} else {
					prerollGeoFence.push(feature);
				}
			}
		}
		const distinctDisplayGeoRecencyMarkers = this.filterGeofenceAndGeoRecency(displayGeoFence, displayGeoRecency);
		const distinctPrerollGeoRecencyMarkers = this.filterGeofenceAndGeoRecency(prerollGeoFence, prerollGeoRecency);

		displayGeoFence = [...[], ...displayGeoFence, ...distinctDisplayGeoRecencyMarkers];
		prerollGeoFence = [...[], ...prerollGeoFence, ...distinctPrerollGeoRecencyMarkers];

		this.displayGeofenceObj = {
			type: displayGeofenceObj.type ? displayGeofenceObj.type : '',
			features: displayGeoFence
		};
		this.displayGeorecencyObj = {
			type: displayGeofenceObj.type ? displayGeofenceObj.type : '',
			features: displayGeoRecency
		};

		this.prerollGeofenceObj = {
			type: prerollGeofenceObj.type ? prerollGeofenceObj.type : '',
			features: prerollGeoFence
		};
		this.prerollGeorecencyObj = {
			type: prerollGeofenceObj.type ? prerollGeofenceObj.type : '',
			features: prerollGeoRecency
		};
		this.doohGeorecencyObj = {
			type: doohGeoRecencyData.type ? doohGeoRecencyData.type : '',
			features: doohGeoRecency
		};
	}

	filterGeofenceAndGeoRecency(geofence, georecency) {
		const distinctRetargetingPoints = georecency.filter((georecenyObj) => {
			if (
				!this.showThirdPartyRTG &&
				georecenyObj.properties.third_party_rtg !== undefined &&
				georecenyObj.properties.third_party_rtg
			) {
				return false;
			}
			if (geofence.length > 0) {
				return !geofence.find((geofenceObj) => {
					return (
						geofenceObj.properties.name === georecenyObj.properties.name &&
						geofenceObj.properties.address === georecenyObj.properties.address
					);
				});
			} else {
				return true;
			}
		});
		return distinctRetargetingPoints;
	}

	generateMapRequiredData(permissions) {
		this.defaultProducts = _.filter(this.defaultProducts, (legend) => {
			return this.filterLegendByPermission(permissions, legend);
		});
		this.geofenceProducts = _.filter(this.geofenceProducts, (legend) => {
			return this.filterLegendByPermission(permissions, legend);
		});
		this.legendItems = this.generateLegendObj();
		const mapObj: MapInterface = <MapInterface>{};
		mapObj.legend = this.updateLegendDataByResponse(this.legendItems);
		mapObj.combinations = this.generateAllPossibleCombinations();
		return mapObj;
	}

	private generateLegendObj() {
		const legend = [];
		if (this.selectedState === MAP_CONSTANTS.STATE.ALL) {
			for (const product of this.defaultProducts) {
				legend.push(product);
			}
			for (const gfProduct of this.geofenceProducts) {
				if (gfProduct.showInLegend) {
					legend.push(gfProduct);
				}
			}
		} else {
			const product: any = _.findWhere(this.defaultProducts, { productKey: this.selectedState });
			if (product) {
				legend.push(product);
				if (product.productKey === MAP_CONSTANTS.STATE.DISPLAY) {
					for (const gfProduct of this.geofenceProducts) {
						if (gfProduct.showInLegend && gfProduct.productRelated !== 'Preroll') {
							legend.push(gfProduct);
						}
					}
				}
				if (product.productKey === MAP_CONSTANTS.STATE.PREROLL) {
					for (const gfProduct of this.geofenceProducts) {
						if (gfProduct.showInLegend && gfProduct.productRelated == 'Preroll') {
							legend.push(gfProduct);
						}
					}
				}
			}
		}
		return legend;
	}

	private filterLegendByPermission(userPermissions, legend) {
		for (const flag of legend.flag) {
			if (_.indexOf(userPermissions, flag) !== -1) {
				return true;
			}
		}
		return false;
	}

	private updateLegendDataByResponse(legendItems: MapLegendItem[]): MapLegendItem[] {
		for (const legend of legendItems) {
			if (legend.productKey === MAP_CONSTANTS.STATE.DISPLAY) {
				legend.isDisabled = this.displayRegions.length <= 0;
				legend.isSelected = !legend.isDisabled;
				const geofenceLegendItem: MapLegendItem = _.findWhere(this.legendItems, {
					productKey: MAP_CONSTANTS.STATE.GEOFENCE
				});
				if (geofenceLegendItem) {
					const hasGeoFenceData =
						this.displayGeofenceObj.features.length > 0 || this.displayGeorecencyObj.features.length > 0;
					geofenceLegendItem.isDisabled = !hasGeoFenceData;
					geofenceLegendItem.isSelected = !geofenceLegendItem.isDisabled;
				}
				this.regionObj[MAP_CONSTANTS.STATE.DISPLAY] = this.displayRegions;
			} else if (legend.productKey === MAP_CONSTANTS.STATE.PREROLL) {
				legend.isDisabled = this.prerollRegions.length <= 0;
				legend.isSelected = !legend.isDisabled;
				const geoVideoLegendItem: MapLegendItem = _.findWhere(this.legendItems, {
					productKey: MAP_CONSTANTS.STATE.GEOVIDEO
				});
				if (geoVideoLegendItem) {
					const hasGeoVideoData =
						this.prerollGeofenceObj.features.length > 0 || this.prerollGeorecencyObj.features.length > 0;
					geoVideoLegendItem.isDisabled = !hasGeoVideoData;
					geoVideoLegendItem.isSelected = !geoVideoLegendItem.isDisabled;
				}
				this.regionObj[MAP_CONSTANTS.STATE.PREROLL] = this.prerollRegions;
			} else if (legend.productKey === MAP_CONSTANTS.STATE.SEM) {
				legend.isDisabled = this.semRegions.length <= 0;
				legend.isSelected = !legend.isDisabled;
				this.regionObj[MAP_CONSTANTS.STATE.SEM] = this.semRegions;
			} else if (legend.productKey === MAP_CONSTANTS.STATE.CTV) {
				legend.isDisabled = this.ctvRegions.length <= 0;
				legend.isSelected = !legend.isDisabled;
				this.regionObj[MAP_CONSTANTS.STATE.CTV] = this.ctvRegions;
			} else if (legend.productKey === MAP_CONSTANTS.STATE.TELEVISION) {
				legend.isDisabled = this.tvRegions.length <= 0;
				legend.isSelected = !legend.isDisabled;
				this.regionObj[MAP_CONSTANTS.STATE.TELEVISION] = this.tvRegions;
			} else if (legend.productKey === MAP_CONSTANTS.STATE.TELEVISION_MIDCO) {
				legend.isDisabled = this.tvRegions.length <= 0;
				legend.isSelected = !legend.isDisabled;
				this.regionObj[MAP_CONSTANTS.STATE.TELEVISION_MIDCO] = this.tvRegions;
			} else if (legend.productKey === MAP_CONSTANTS.STATE.RADIO) {
				legend.isDisabled = this.radioRegions.length <= 0;
				legend.isSelected = !legend.isDisabled;
				this.regionObj[MAP_CONSTANTS.STATE.RADIO] = this.radioRegions;
			} else if (legend.productKey === MAP_CONSTANTS.STATE.SIMPLIFI_CTV) {
				legend.isDisabled = this.simplifiCTVRegions.length <= 0;
				legend.isSelected = !legend.isDisabled;
				this.regionObj[MAP_CONSTANTS.STATE.SIMPLIFI_CTV] = this.simplifiCTVRegions;
			} else if (legend.productKey === MAP_CONSTANTS.STATE.TRITON_AUDIO) {
				legend.isDisabled = this.tritonRadioRegions.length <= 0;
				legend.isSelected = !legend.isDisabled;
				this.regionObj[MAP_CONSTANTS.STATE.TRITON_AUDIO] = this.tritonRadioRegions;
			} else if (legend.productKey === MAP_CONSTANTS.STATE.RESPONSIVE_DISPLAY) {
				legend.isDisabled = this.responsiveDisplayRegions.length <= 0;
				legend.isSelected = !legend.isDisabled;
				this.regionObj[MAP_CONSTANTS.STATE.RESPONSIVE_DISPLAY] = this.responsiveDisplayRegions;
			} else if (legend.productKey === MAP_CONSTANTS.STATE.GAM) {
				legend.isDisabled = this.gamRegions.length <= 0;
				legend.isSelected = !legend.isDisabled;
				this.regionObj[MAP_CONSTANTS.STATE.GAM] = this.gamRegions;
			}
		}
		return legendItems;
	}

	private generateAllPossibleCombinations() {
		const nonDependentItems = _.where(this.legendItems, { isDependent: false });
		const enabledLegendItems = _.where(nonDependentItems, { isDisabled: false });
		const productNames = _.pluck(enabledLegendItems, 'productKey');
		let combinations = UtilityService.getSubArrays(productNames.reverse());
		combinations = _.sortBy(combinations, (arr: any) => {
			return arr.length;
		});
		return this.generateCombinationObject(combinations);
	}

	private generateCombinationObject(combinationArray: any) {
		const combinationObj: any = [];
		const filter = ['in', 'gcd_id'];
		for (const combinations of combinationArray) {
			let tempObj: any = {};
			let opacity: any[] = ['match', ['get', 'gcd_id']];
			for (const combination of combinations) {
				const geos = [];
				const localIds = [];
				const regions = this.regionObj[combination];
				_.map(regions, (value) => {
					opacity.push(parseInt(value[this.filterProperty]), parseFloat(value['opacity']));
					geos.push(parseInt(value[this.filterProperty]));
					localIds.push(value[this.localIdProperty]);
				});
				if (_.isEmpty(tempObj)) {
					opacity.push(0);
					tempObj = {
						regionData: regions,
						regions: geos,
						key: combination,
						filters: _.union(filter, geos),
						localIds: localIds,
						opacity: opacity,
						status: localIds.length === 0
					};
				} else {
					if (!opacity[opacity.length - 1]) {
						const slicedArray = tempObj.opacity.slice(0, tempObj.opacity.length - 1);
						opacity = _.union(slicedArray, opacity);
					}
					if (_.lastIndexOf(combinations, combination) === combinations.length - 1) {
						opacity.push(0);
					}
					opacity = opacity.filter((item) => item !== 0); // removes all 0's from array when different products are merged(needed to render the polygons)
					opacity.push(0); // need to push one 0 as default
					opacity = _.unique(opacity);
					tempObj.regionData = _.union(tempObj.regionData, regions);
					tempObj.regions = _.union(tempObj.regions, geos);
					tempObj.localIds = _.union(tempObj.localIds, localIds);
					tempObj.filters = _.union(filter, tempObj.regions);
					tempObj.opacity = opacity;
					tempObj.key = tempObj.key + '_' + combination;
				}
			}
			tempObj.length = combinations.length;
			combinationObj.push(tempObj);
		}
		return combinationObj;
	}

	processRegionDataOnSelection(regionData) {
		if (!_.isEmpty(regionData)) {
			return this.processAndBuildLiftData(regionData);
		} else {
			return {};
		}
	}

	private processAndBuildLiftData(regions) {
		const liftArray = [];
		this.setBinCount(regions);
		let currentPath = this.analyticsDataModel.getCurrentPath();
		let key = this.getSelectedLegendKeys();
		for (const region of regions) {
			const liftValue = region.lift;
			if (
				((currentPath === 'overview' && parseInt(region.display)) ||
					parseInt(region.preroll) ||
					parseInt(region.gam) ||
					parseInt(region[currentPath])) &&
				liftValue !== 'n/a'
			) {
				if (key?.includes('_') || region.lift[key] == true) {
					const lift = parseFloat(liftValue.average_lift);
					if (lift >= 1) {
						const tempObj: any = {};
						tempObj.zip = liftValue.zip;
						tempObj.gcdId = parseInt(region.gcd_id);
						tempObj.lift = lift > 99 ? 99 : lift;
						liftArray.push(tempObj);
					}
				}
			}
		}
		if (liftArray.length > 0) {
			return this.processLiftData(liftArray);
		} else {
			return {};
		}
	}
	protected getSelectedLegendKeys() {
		const nonDependentItems = _.where(this.legendItems, { isDependent: false });
		const selectedLegendItems = _.where(nonDependentItems, { isSelected: true });
		const productKeys = _.pluck(selectedLegendItems, 'productKey');
		return this.getCombinationKeyByProductKeys(productKeys);
	}

	protected getCombinationKeyByProductKeys(productKeys: string[]) {
		return productKeys.join('_');
	}

	private setBinCount(regions) {
		if (regions.length >= 5) {
			this.barsCount = 5;
		} else if (1 < regions.length && regions.length < 5) {
			this.barsCount = regions.length;
		} else if (regions.length <= 1) {
			this.barsCount = 1;
		}
	}

	private processLiftData(liftObjArr: any) {
		let liftValues = _.pluck(liftObjArr, 'lift');
		liftValues = _.sortBy(liftValues);
		if (liftValues.length > 0) {
			return this.buildBindata(liftObjArr, liftValues);
		} else {
			return {};
		}
	}

	private quantile(array, percentile) {
		const index = (percentile / 100) * (array.length - 1);
		let result = 0,
			i = 0,
			fraction = 0;
		if (Math.floor(index) === index) {
			result = array[index];
		} else {
			i = Math.floor(index);
			fraction = index - i;
			result = array[i] + (array[i + 1] - array[i]) * fraction;
		}
		return result;
	}

	private buildBindata(liftObjArray, liftValues) {
		const length = _.uniq(liftValues).length;
		const binCount = length >= this.barsCount ? this.barsCount : length;
		const q = parseInt((length / binCount).toString());
		const r = parseInt((length % binCount).toString());
		let startIndex = 0;
		let endIndex = 0;
		const tempObj: any = {};
		for (let i = 1; i <= binCount; i++) {
			const binObj: any = {};
			binObj.name = 'Bin-' + i;
			binObj.count = q + (i + r > binCount ? 1 : 0);
			if (i === binCount) {
				endIndex = liftValues.length;
			} else {
				endIndex = this.getEndIndexFromArray(liftValues, startIndex + binObj.count);
			}
			const slicedObj = this.getSlicedObject(liftObjArray, startIndex, endIndex);
			binObj.liftValues = slicedObj.lift;
			binObj.gcdId = slicedObj.gcdId;
			binObj.regions = slicedObj.regions;
			binObj.lift = this.calculateRangeFromArrayAndIndex(liftValues, startIndex, endIndex);
			startIndex = endIndex;
			tempObj[i - 1] = binObj;
		}
		return tempObj;
	}

	private calculateRangeFromArrayAndIndex(liftArray, startIndex, endIndex) {
		let endLift = 0;
		let startLift = 0;
		if (endIndex !== liftArray.length) {
			const endValue = liftArray[endIndex - 1];
			const startValue = liftArray[endIndex];
			endLift = (startValue + endValue) / 2;
		} else {
			endLift = liftArray[liftArray.length - 1];
		}
		if (startIndex === 0) {
			startLift = liftArray[startIndex];
		} else {
			const endValue = liftArray[startIndex - 1];
			const startValue = liftArray[startIndex];
			startLift = (startValue + endValue) / 2;
		}

		const lift = startLift.toFixed(1) + 'x - ' + endLift.toFixed(1) + 'x';
		return lift;
	}

	private getEndIndexFromArray(liftArray, endIndex) {
		const endValue = liftArray[endIndex - 1];
		const index = liftArray.lastIndexOf(endValue);
		if (endIndex < index + 1) {
			return index + 1;
		}
		return endIndex;
	}

	private getSlicedObject(liftObjArray, startIndex, endIndex) {
		const sortedLiftObj = _.sortBy(liftObjArray, 'lift');
		const slicedObj = sortedLiftObj.slice(startIndex, endIndex);
		const zips = _.pluck(slicedObj, 'zip');
		const gcdId = _.pluck(slicedObj, 'gcdId');
		const lift = _.pluck(slicedObj, 'lift');
		return { regions: zips, gcdId: gcdId, lift: lift };
	}
}
